export const GET_COMPANY_ID = 'GET_COMPANY_ID';
export const SET_COMPANY = 'SET_COMPANY';
export const CACHE_COMPANY = 'CACHE_COMPANY';
export const SET_COMPANIES = 'SET_COMPANIES';
export const CACHE_COMPANIES = 'CACHE_COMPANIES';
export const SET_COMPANY_BY_ID = 'SET_COMPANY_BY_ID';
export const CACHE_COMPANY_BY_ID = 'CACHE_COMPANY_BY_ID';
